/**
 * Represents locales we support.
 * Should be kept in sync with https://setup.intlservices.microsoft.com/Home/ConfigSettings?TeamID=520
 */

export interface ILanguageInformation {
  isRtl?: boolean
}

const supportedLanguages: { [languageCode: string]: ILanguageInformation } = {
  'ar': {
    'isRtl': true
  },
  'bg': {},
  'cs': {},
  'cy': {},
  'da': {},
  'de': {},
  'el': {},
  'en-US': {},
  'en-GB': {},
  'es': {},
  'et': {},
  'eu': {},
  'fi': {},
  'fr': {},
  'gu': {},
  'he': {
    'isRtl': true
  },
  'hi': {},
  'hr': {},
  'hu': {},
  'id': {},
  'is': {},
  'it': {},
  'ja': {},
  'ka': {},
  'kk': {},
  'ko': {},
  'lt': {},
  'lv': {},
  'mr': {},
  'ms': {},
  'nb-NO': {},
  'nl': {},
  'pl': {},
  'pt-BR': {},
  'pt-PT': {},
  'ro': {},
  'ru': {},
  'sk': {},
  'sl': {},
  'sr-Cyrl-RS': {},
  'sr-Latn-RS': {},
  'sv': {},
  'th': {},
  'tr': {},
  'uk': {},
  'vi': {},
  'zh-Hans': {},
  'zh-Hant': {}
}

export const languageModuleMap: { [languageCode: string]: string }= {
  'ar': 'ar',
  'bg': 'bg',
  'cs': 'cs',
  'cy': 'cy',
  'da': 'da',
  'de': 'de',
  'el': 'el',
  'en-US': 'en-US',
  'en-GB': 'en-GB',
  'es': 'es',
  'et': 'et',
  'eu': 'eu',
  'fi': 'fi',
  'fr': 'fr',
  'gu': 'gu',
  'he': 'he',
  'hi': 'hi',
  'hr': 'hr',
  'hu': 'hu',
  'id': 'id',
  'is': 'is',
  'it': 'it',
  'ja': 'ja',
  'ka': 'ka',
  'kk': 'kk',
  'ko': 'ko',
  'lt': 'lt',
  'lv': 'lv',
  'mr': 'mr',
  'ms': 'ms',
  'nb-NO': 'nb-NO',
  'nl': 'nl',
  'pl': 'pl',
  'pt-BR': 'pt-BR',
  'pt-PT': 'pt-PT',
  'ro': 'ro',
  'ru': 'ru',
  'sk': 'sk',
  'sl': 'sl',
  'sr-Cyrl-RS': 'sr-Cyrl-RS',
  'sr-Latn-RS': 'sr-Latn-RS',
  'sv': 'sv',
  'th': 'th',
  'tr': 'tr',
  'uk': 'uk',
  'vi': 'vi',
  'zh-Hans': 'zh-Hans',
  'zh-Hant': 'zh-Hant',
  'zh-CN': 'zh-Hans',
  'zh-TW': 'zh-Hant'
}

export default supportedLanguages